import { HttpClient } from './HttpClient';
import globalCache from '@shared/lib/GlobalCache';

export interface Country {
  id: number;
  name: string;
  code: string;
  iso3: string;
  phoneCode: string;
}

export interface CountryOption {
  id: string;
  name: string;
}

export class CountriesApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<CountryOption[]> {
    return globalCache.getOrSet('countries-options', async () => {
      const raw = await this.httpClient.get<any>('/countries');
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((c: any) => ({
        id: String(c.id),
        name: c.name,
      }));
    });
  }

  async getCountries(): Promise<Country[]> {
    return globalCache.getOrSet('countries-full', async () => {
      const raw = await this.httpClient.get<any>('/countries');
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((c: any) => ({
        id: c.id,
        name: c.name,
        code: c.iso2,
        iso3: c.iso3,
        phoneCode: c.phoneCode || '',
      }));
    });
  }
}